import $ from 'jquery';
import core from '../core';

const MODAL_SELECTOR = '.js-video-modal';
const MODAL_CONTENT_SELECTOR = '.js-video-modal__content';

/**
 * Setup
 */
function setup() {
    const $el = $(MODAL_SELECTOR);

    if (! $el.length) {
        return;
    }

    $el.on('show.bs.modal', onShowModal);
    $el.on('hide.bs.modal', onHideModal);
}

/**
 * On show menu
 *
 * @param {Object} evt
 */
function onShowModal(evt) {
    const $modal = $(evt.target);
    const $toggle = $(evt.relatedTarget);

    // console.log($toggle, 'onShowModal :: $target');

    buildModalContent($toggle, $modal);
}

/**
 * On hide menu
 *
 * @param {Object} evt
 */
function onHideModal(evt) {
    const $modal = $(evt.target);
    const $iframe = $modal.find('iframe');
    const iframeSrc = $iframe.attr('src').replace('autoplay=1', 'autoplay=0');

    $iframe.attr('src', iframeSrc);
}

/**
 * @param {Object} $toggle
 * @param {Object} $modal
 */
function buildModalContent($toggle, $modal) {
    const $content = $modal.find(MODAL_CONTENT_SELECTOR);
    const iframeSrc = $toggle.attr('href');
    const iframeTitle = $toggle.attr('title');
    const iframeMarkup = `<iframe src="${iframeSrc}" title="${iframeTitle}" width="500" height="281" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>`;

    $content.html(iframeMarkup);
}

core.Ready(setup);
